import { render, staticRenderFns } from "./ProvedoresAnaliticosPage.vue?vue&type=template&id=1b17b736&scoped=true"
import script from "./ProvedoresAnaliticosPage.vue?vue&type=script&lang=js"
export * from "./ProvedoresAnaliticosPage.vue?vue&type=script&lang=js"
import style0 from "./ProvedoresAnaliticosPage.vue?vue&type=style&index=0&id=1b17b736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17b736",
  null
  
)

export default component.exports